<template>
  <div class="d-flex justify-center">
    <v-btn v-if="primaryButtonIcon || primaryButtonText"
      color="primary"
      class="mr-2"
      :large="showLargeButtons"
      :disabled="!isOnline"
      @click="$emit('primary-button-clicked')">
      <v-icon v-if="primaryButtonIcon">{{ primaryButtonIcon }}</v-icon>
      <div v-if="primaryButtonText">{{ primaryButtonText }}</div>
    </v-btn>
    <v-btn v-if="secondaryButtonIcon || secondaryButtonText"
      color="secondary"
      class="mr-2"
      :large="showLargeButtons"
      :disabled="!isOnline"
      @click="$emit('secondary-button-clicked')">
      <v-icon v-if="secondaryButtonIcon">{{ secondaryButtonIcon }}</v-icon>
      <div v-if="secondaryButtonText">{{ secondaryButtonText }}</div>
    </v-btn>
    <v-btn v-if="tertiaryButtonIcon || tertiaryButtonText"
      color="info"
      :large="showLargeButtons"
      :disabled="!isOnline"
      @click="$emit('tertiary-button-clicked')">
      <v-icon v-if="tertiaryButtonIcon">{{ tertiaryButtonIcon }}</v-icon>
      <div v-if="tertiaryButtonText">{{ tertiaryButtonText }}</div>
    </v-btn>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    showLargeButtons: Boolean,

    primaryButtonText: String,
    primaryButtonIcon: String,

    secondaryButtonText: String,
    secondaryButtonIcon: String,

    tertiaryButtonText: String,
    tertiaryButtonIcon: String
  },
  computed: {
    ...mapState(['isOnline'])
  }
}
</script>